import ReactionEngine from '../models/ReactionEngine';
import { ELEMENTS } from './elements';
import { COMPOUNDS } from './compounds';
import { CURATED_REACTIONS } from './chemistry/curatedReactions';

export const ALL_SUBSTANCES = [...ELEMENTS, ...COMPOUNDS];

export function createReactionEngine() {
  return new ReactionEngine(ALL_SUBSTANCES, CURATED_REACTIONS);
}
